import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialConstructConfirmPlacement = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.constructWindmill_confirmPlacement) {
        return undefined;
    }
    if (nextTutorialStepConfig.buildingId === undefined) {
        return undefined;
    }
    return path;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialConstructConfirmPlacement.ts
// module id = 2463
// module chunks = 3